import React from "react";
import { reportError } from "../lib/sentry";

/**
 * Sprint S-8 · ErrorBoundary global · fallback bonito + auto-report Sentry.
 */
export class GlobalErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    try { reportError(error, { componentStack: info?.componentStack }); } catch {}
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info?.componentStack);
  }
  reset = () => this.setState({ error: null });
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-screen bg-[var(--ag-midnight)] text-[var(--ag-text)] grid place-items-center px-6" data-testid="global-error-boundary">
        <div className="ag-card max-w-lg w-full p-8 text-center">
          <div className="text-[10px] uppercase tracking-[0.25em] text-red-300">Algo no ha ido bien</div>
          <h1 className="font-display font-black text-3xl tracking-tighter mt-3">No se pudo cargar esta pantalla</h1>
          <p className="text-[var(--ag-text-dim)] mt-3 text-sm">
            El equipo recibirá automáticamente el detalle del error. Prueba a recargar la página o vuelve al inicio.
          </p>
          <pre className="mt-4 text-[10px] text-left text-red-300/80 bg-black/30 p-3 rounded-sm overflow-x-auto max-h-32" data-testid="eb-error-message">
            {String(this.state.error?.message || this.state.error)}
          </pre>
          <div className="flex gap-2 justify-center mt-5">
            <button onClick={() => window.location.reload()} className="h-10 px-4 ag-btn-gold uppercase tracking-wider text-xs font-bold" data-testid="eb-reload">
              Recargar
            </button>
            <a href="/" className="h-10 px-4 rounded-sm border border-[var(--ag-border)] text-white text-xs font-bold uppercase tracking-wider inline-flex items-center" data-testid="eb-home">
              Volver al inicio
            </a>
          </div>
        </div>
      </div>
    );
  }
}
